import Moment from 'moment';
import { Fetch } from './FetchApi';

export const FetchConfig = async (url) => {
  const config = await FetchUrl(url);
  if (config && config.eventPanel && config.eventPanel.events) {
    const promises = [];
    for (let i = 0; i < config.awardPanel.events.length; i++) {
      const event = config.awardPanel.events[i];
      if (event && event.contentUrl) {
        promises.push(FetchUrl(GetUrl(event.contentUrl)).then((content) => event.content = content));
      }
    }
    for (let i = 0; i < config.eventPanel.events.length; i++) {
      const event = config.eventPanel.events[i];
      if (event && event.contentUrl) {
        promises.push(FetchUrl(GetUrl(event.contentUrl)).then((content) => event.content = content));
      }
    }
    await Promise.all(promises);
  }
  return config;
}

export const UpdateConfig = (config) => {
  // console.log('UpdateConfig', config);
  if (config && config.awardPanel && config.awardPanel.events) {
    for (let i = 0; i < config.awardPanel.events.length; i++) {
      updateEvent(config.awardPanel.events[i]);
      updateSurvey(config.awardPanel.events[i]);
    }
  }
  if (config && config.eventPanel && config.eventPanel.events) {
    for (let i = 0; i < config.eventPanel.events.length; i++) {
      updateEvent(config.eventPanel.events[i]);
      updateSurvey(config.eventPanel.events[i]);
    }
  }
  return config;
}

const updateEvent = (event) => {
  // console.log('updateEvent', event);
  event.isLive = false;
  event.isReplay = false;
  event.isVoD = false;
  event.isUpcoming = false;
  event.isPending = false;
  event.isExpired = false;
  const publishDate = Moment(event.publishDate).valueOf();
  const startDate = Moment(event.startDate).valueOf();
  const endDate = Moment(event.endDate).valueOf();
  const expireDate = Moment(event.expireDate).valueOf();
  const now = new Date().getTime();
  if (now >= expireDate) {
    event.isExpired = true;
  }
  else if (now < publishDate) {
    event.isUpcoming = true;
  }
  else if (event.startDate && event.endDate && (startDate <= now) && (now < endDate)) {
    event.isLive = true;
  }
  else if (event.startDate && event.endDate && (endDate < now)) {
    event.isReplay = true;
  }
  else {
    event.isPending = true;
  }
}

const updateSurvey = (event) => {
  //console.log('updateSurvey', event);
  if (event && event.content && event.content.tabs) {
    for (let i = 0; i < event.content.tabs.length; i++) {
      const tab = event.content.tabs[i];
      if (tab.survey && tab.survey.url) {
        tab.survey.isOpen = false;
        const now = new Date().getTime();
        if (tab.survey.startDate && tab.survey.endDate) {
          const startDate = Moment(tab.survey.startDate).valueOf();
          const endDate = Moment(tab.survey.endDate).valueOf();
          if ((startDate <= now) && (now < endDate)) {
            tab.survey.isOpen = true;
          }
        }
      }
    }
  }
}

export const SaveConfig = (config) => {
  //localStorage.setItem('config', JSON.stringify(config));
};

export const RetrieveConfig = () => {
  // try {
  //   const config = localStorage.getItem('config');
  //   if (config) {
  //     return JSON.parse(config)
  //   }
  // }
  // catch (e) {
  //   console.log(e);
  // }
};

export const GetUrl = (url) => {
  return url + '?v=' + new Date().getTime();
}

export const GetDefaultVideo = (config) => {
  // console.log('GetDefaultVideo', config);
  if (config && config.content && config.content.videos) {
    for (let i = 0; i < config.content.videos.length; i++) {
      if (config.content.defaultVideo === config.content.videos[i].id) {
        return config.content.videos[i];
      }
    }
  }
};

export const GetEvent = (config, id) => {
  //console.log('GetEvent', config, id);
  if (config && config.awardPanel && config.awardPanel.events) {
    for (let i = 0; i < config.awardPanel.events.length; i++) {
      const event = config.awardPanel.events[i];
      if (event.id === id) {
        return event;
      }
    }
  }
  if (config && config.eventPanel && config.eventPanel.events) {
    for (let i = 0; i < config.eventPanel.events.length; i++) {
      const event = config.eventPanel.events[i];
      if (event.id === id) {
        return event;
      }
    }
  }
};

export const GetSurvey = (config, id) => {
  //console.log('GetSurvey', config, id);
  if (config && config.content && config.content.tabs) {
    for (let i = 0; i < config.content.tabs.length; i++) {
      const tab = config.content.tabs[i];
      if (tab.survey && tab.survey.url) {
        return tab.survey;
      }
    }
  }
};

const FetchUrl = async (url) => {
  //console.log('Fetch Url: ', url);
  const payload = {
    method: 'GET',
  }
  return await Fetch(url, payload);
};

